export default {
  en: {
    get: {
      title: 'The resource could not be loaded | The resources could not be loaded',
      description: 'Please try again clicking in reload button for load {entity}.',
    },
    post: {
      title: 'Could not create the {entity}',
      description: 'Please try create again.',
    },
    patch: {
      title: 'Could not edit the {entity}',
      description: 'Please try edit again',
    },
    delete: {
      title: 'Could not delete the {entity}',
      description: 'Please try delete again.',
    },
  },
  es: {
    get: {
      title: 'No se ha podido cargar el recurso | No se han podido cargar los recursos',
      description: 'Intente nuevamente haciendo clic en recargar para cargar.',
    },
    post: {
      title: 'No se ha podido crear el {entity} | No se han podido crear los {entity}',
      description: 'Intente crear nuevamente.',
    },
    patch: {
      title: 'No se ha podido editar el {entity} | No se han podido editar los {entity}',
      description: 'Intente editar nuevamente.',
    },
    delete: {
      title: 'No se ha podido eliminar el {entity} | No se han podido eliminar los {entity}',
      description: 'Intente eliminar nuevamente.',
    }
  },
};
